import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import Divider from '@mui/material/Divider';
import RowTable from './RowTable';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import BottomButtons from './BottomButtons';
import useMediaQuery from '@mui/material/useMediaQuery';
import {Theme} from './Theme';
import {Payment} from './Inc';
import {Tools} from './Tools';
import useStyles from './Styles';

interface Props {
    payment: Payment,
    yes():void,
    no():void,
    isOpen:boolean,
}

const PaymentConfirm = (props:Props)=> {
    const classes = useStyles();
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));
    if( !props.isOpen ){
        return (null);
    }

    return (
		<Dialog
			fullScreen={fullScreen}
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.no();
				}
			}}
		>
			<DialogTitle color='primary'>支払申請</DialogTitle>
			<DialogContent>
				<div style={{marginBottom:"1em",fontSize:"90%"}}>
					金額をご確認の上、「申請する」を押して下さい。<br/>
				</div>
				<Divider/>
				<Table style={{marginBottom:"1em"}}>
					<TableBody>
						<RowTable name="売上残高" value={
							<div style={{textAlign:"right",fontSize:"140%"}}>
							{Tools.comma(props.payment.sales)}円
							</div>
						}/>
						<RowTable name="販売手数料" value={
							<div style={{textAlign:"right",fontSize:"140%"}}>
							-{Tools.comma(props.payment.fee)}円
							</div>
						}/>
						<RowTable name="商品返送料等" value={
							<div style={{textAlign:"right",fontSize:"140%"}}>
							-{Tools.comma(props.payment.fee_etc)}円
							</div>
						}/>
						<RowTable name="支払手数料" value={
							<div style={{textAlign:"right",fontSize:"140%"}}>
							-{props.payment.cost}円
							</div>
						}/>
						<RowTable name="振込金額" value={
							<div style={{textAlign:"right",fontSize:"140%"}}>
							{Tools.comma(props.payment.transfer)}円
							</div>
						}/>
					</TableBody>
				</Table>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='申請する' onClick1={props.yes} button2='やめる' onClick2={props.no} bottom={0}/>
			</DialogActions>
        </Dialog>
    );
}

export default PaymentConfirm;
